import { render, staticRenderFns } from "./tagSelectAgent.vue?vue&type=template&id=52196208&scoped=true&"
import script from "./tagSelectAgent.vue?vue&type=script&lang=js&"
export * from "./tagSelectAgent.vue?vue&type=script&lang=js&"
import style0 from "./tagSelectAgent.vue?vue&type=style&index=0&id=52196208&lang=scss&scoped=true&"
import style1 from "./tagSelectAgent.vue?vue&type=style&index=1&id=52196208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52196208",
  null
  
)

export default component.exports